module.exports = __webpack_public_path__ + "static/media/loaderImg.2cedc277.gif";